/**
 * created by mgg
 * 新媒体矩阵所有路由
 */
import newMediaManagement from "../pms/newMediaManagement/NewMediaManage";   //媒体管理
import PlatformMaintenance from "../pms/platformMaintenance/PlatformMaintenance";   //平台维护
import MaintenanceField from "../pms/platformMaintenance/MaintenanceField";   //维护字段
import NewMediaOverview from "../pms/newMediaOverview/NewMediaOverview";   //媒体总览
import MediaManagementList from "../pms/mediaManagementList/MediaManagementList";
import ContenManagement from "../pms/contenManagement/ContenManagement";
import ManageControlStatistics from "../pms/manageControlStatistics/ManageControlStatistics";
import ContentSecurityManagement from "../pms/contentSecurityManagement/ContentSecurityManagement";
import MessageNotice from "../pms/messageNotice/MessageNotice";
import DouYinLink from "../pms/newMediaManagement/DouYinLink";

 export  const  router =[
    {
        path: "/view/newMediaMatrix/pms/newMediaOverview/newMediaOverview",
        componentTitle:'pms媒体总览',
        component: NewMediaOverview
    },
     {
         path: "/view/newMediaMatrix/pms/newMediaMatrix/mediaManagement",
         componentTitle:'pms媒体管理',
         component: newMediaManagement
     },
     {
         path: "/view/newMediaMatrix/pms/mediaManagementList",
         componentTitle:'pms媒体账号管理',
         component: MediaManagementList
     },
    {
        path: "/view/newMediaMatrix/pms/contenManagement",
        componentTitle:'pms内容管理',
        component: ContenManagement
    },
    {
        path: "/view/newMediaMatrix/pms/manageControlStatistics",
        componentTitle:'pms统计分析',
        component: ManageControlStatistics
    },
    {
        path: "/view/newMediaMatrix/pms/contentSecurityManagement",
        componentTitle:'pms安全管理',
        component: ContentSecurityManagement
    },
     {
         path: "/view/newMediaMatrix/pms/messageNotice/messageNotice",
         componentTitle:'pms消息通知',
         component: MessageNotice
     },
    {
        path: "/view/newMediaMatrix/pms/platformMaintenance/platformMaintenance",
        componentTitle:'pms平台维护',
        component: PlatformMaintenance
    },
    {
        path: "/view/newMediaMatrix/pms/platformMaintenance/maintenanceField/:id",
        componentTitle:'pms维护字段',
        component: MaintenanceField
    },
     {
         path: "/view/newMediaMatrix/pms/newMediaManagement/douYinLink",
         componentTitle:'pms抖音链接获取方式',
         component: DouYinLink,frame:'no-frame'

     },
];

